import React from 'react'
import CustomSelect from '../../../../../../Util/CustomSelect/CustomSelect'
import './EventInputWithDropdown.css'
import { PRICE_TYPE } from '../../../../../../Util/helper';

export default function CreateEventInputDropdown(props) {
	return (
		<div className={`createEventInputWithDropdownWrapper ${props.wrapperClass ? props.wrapperClass : ''}`}>
			{props.deleteButton && <button className='createEventInputDeleteButton' onClick={props.deleteButton} />}
			<div className="price-input">
				<label className='createEventInputLabel' htmlFor={props.id} style={{ gridColumn: 'span 2' }}>{props.label}</label>
				<input className='createEventInput' placeholder='Enter price' type={props.type ? props.type : 'text'} id={props.id} value={props.value} onChange={(e) => props.onChange({
					target: {
						name: props.name,
						value: e.target.value,
					}
				})} />
			</div>
			<div className="priceType-field">
				<label className='label' htmlFor='eventPrice'>Price Type</label>
				<CustomSelect
					uniqueKey={'unique'}
					data={[
						{
							id: 'person',
							title: 'Person',
						},
						{
							id: 'group',
							title: 'Group'
						}
					]}
					placeholder={props.selectedOption ? PRICE_TYPE[props.selectedOption] : 'Select option'}
					type={'text'}
					onSelect={(data) => data && props.onDropdownChange(data.id)}
					selector="title"
				/>
			</div>
		</div>
	)
}
